export default "__VITE_ASSET__83a4bc1f__"